import { Trans } from "@lingui/macro";
import type { Brand } from "@src/__generated__/urql-graphql";
import { useStore } from "@src/utils/hooks";
import type React from "react";
import type { FC } from "react";

interface AddTitleProps {
  brand?: Pick<Brand, "name" | "code" | "numeric_code">;
}

const AddTitle: FC<React.PropsWithChildren<AddTitleProps>> = ({ brand }) => {
  const { workspaceStore } = useStore();

  return brand ? (
    <Trans>
      Add contact to brand{" "}
      {`${brand.name} (${brand.code}${workspaceStore.settings?.enableAdditionalBrandNumericCode && brand.numeric_code ? `/${brand.numeric_code}` : ""})`}
    </Trans>
  ) : (
    <Trans>Add contact</Trans>
  );
};

export { AddTitle };
